<template>
  <div class="row ">
    <div class="col-md-12">

      <div 
        v-if="!success && errorMessage"
        class="alert alert-danger alert-dismissible fade show" role="alert">
        {{errorMessage}}
      </div>

      <b-form
        @submit.prevent="inviteEmails"
        ref="form"
      >
        <!-- <TextField 
          placeholder="Enter email"
          label="Email addresses"
          name="email"
          help="Enter up to 5 email addresses, separated by a comma."
        /> -->
        
        <div class="form-group">
          <label class="form-label">Email addresses</label>

          <InputTag 
            placeholder="Enter email"
            label="name" 
            v-model="model.emails"
            add-tag-on-blur
            validate="email"
            class="vue-input-tag-custom"
          >
          </InputTag>

          <span class="text-muted">Enter up to 10 email addresses, separated by a comma.</span>

        </div>


        <div class="form-group mt-3 mt-sm-0" v-if="type == 'users'">
          <label for="default">Access Type</label>
          <b-form-select v-model="model.access_type" :options="access_type_options"></b-form-select>
        </div>

        <div class="form-group mt-3 mt-sm-0"  v-if="type == 'users' && model.access_type == 'recruitment'">
          <label for="default">Recruitment Type</label>
          <b-form-select v-model="model.recruitment_type" :options="recruitment_type_options"></b-form-select>
        </div>

        <div class="form-group row">
          <div class="col-md-12">
              <!-- <button type="submit" class="btn btn-primary mr-1">
                <i class="uil-envelope-add"></i> Invite
              </button> -->
              <!-- <Button
                class="mr-1 btn-block"
                :loading="loading"
              >Invite</Button> -->
          </div>
        </div>

      </b-form>
    </div>
  </div>
</template>

<script>
/* import TextField from '@components/form/textfield' */
/* import Button from '@components/buttons/button' */
import InputTag from 'vue-input-tag'
import {required} from 'vuelidate/lib/validators'
import FormMixin from '@mixins/form'
import { mapActions } from 'vuex'

export default {
  mixins:[ FormMixin ],
  props:['type'],
  data(){
    let options = [
      { value: null, text: 'Please select a Type' },
      { value: 'company', text: 'Company' },
      { value: 'individual', text: 'Individual' }
    ]
    let defaultType = ''
    let defaultAccess = ''

    if(this.type == 'users'){
      options = []
    }

    return {
      model:{
        access_type:defaultAccess,
        recruitment_type:defaultType,
        emails: [],
        type:this.type
      },
      success:false,
      access_type_options: [],
      recruitment_type_options: options,
      errorMessage:''
    }
  },
  components:{ /* TextField,  */InputTag/* , Button */ },
  methods:{
    ...mapActions('user', ['invite']),
    inviteEmails(){

			if (this.validateForm()) {
				this.toggleLoading()
				return;
      }

      this.invite(this.model).then(res => {
        this.toggleLoading()
        this.$emit('onInvited')

        if(res.data.success == false){
          this.$bvToast.toast(res.data.msg, {
            title: 'Notification',
            variant:'danger',
            autoHideDelay:10000
          })
        }

			}).catch(err => {
        let errorData = err.response.data

        this.toggleLoading()
        if(this.$v && err.response.data){
          Object.keys(err.response.data).forEach(key => {
            if(this.$v.model[key]){
              this.$v.model[key].errorMessage = err.response.data[key]
            }
          })
        }
        if(errorData.msg){
          this.errorMessage = errorData.msg
        }

			})
    },
    clear(){
      this.model.access_type =''
      this.model.recruitment_type =''
      this.model.emails = []
    }
  },
  mounted(){
    let options = [
      { value: null, text: 'Please select a Type' }
    ]
    if(this.user.role.role == 'administration'){
      options.push(
        { value: 'administration', text: 'Administrator' }
      )
      /* options.push(
        { value: 'recruitment', text: 'Recruitment' }
      ) */
    }

    options.push({ value: 'staff', text: 'Staff' })

    this.access_type_options = options
  },
  validations: {
		model:{
			emails: {
				required
      }
		}
	}
}
</script>